import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {ChallengeCardComponent} from '@components/challenge-card/challenge-card.component';
import {TranslatePipe} from '@ngx-translate/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
	selector: 'peps-place-information',
	imports: [
		ChallengeCardComponent,
		TranslatePipe
	],
	templateUrl: './information.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('300ms ease-out', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ opacity: 0 }))
			])
		]),
		trigger('scaleInOut', [
			transition(':enter', [
				style({ transform: 'scale(0.8)' }),
				animate('300ms ease-out', style({ transform: 'scale(1)' }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ transform: 'scale(0.8)' }))
			])
		])
	]
})
export class InformationComponent {

	@Output() close = new EventEmitter<void>();

	protected onBackgroundClick(event: Event) {
		if (event.target === event.currentTarget) {
			this.closeInformationModal();
		}
	}

	protected closeInformationModal() {
		this.close.emit();
	}
}
